import { Box } from "@mui/material";
import StyledButton from "../../../../../components/app/StyledButton";
import { FlexCenterWrapper } from "../../../../../components/DefaultNoDataWrapper";

const WidgetLayout = () => {
  return (
    <Box
      minHeight="100vh"
      display="flex"
      flexDirection="column"
      justifyContent="center"
    >
      <FlexCenterWrapper>
        <StyledButton
          variant="outlined"
          id="widget-ech-find-doctor"
          label={"Find a Doctor"}
        />
        <StyledButton
          id="widget-ech-request-appointment"
          label={"Request Appointment"}
        />
      </FlexCenterWrapper>
    </Box>
  );
};

export default WidgetLayout;
